import React from 'react';
import PatientIntakeForm from './patientIntake/PatientIntakeForm';

const PatientRegister: React.FC = () => <PatientIntakeForm />;

export default PatientRegister;
